import {elementAcceptingRef} from '@mui/utils';
import React from 'react';

export const CeldaSolicitarCambios = (props) => {
	/* Destructuring the props object. */
	const {index, index2, lista, modoMobile, leyendaCuidados, seleccionarDia2} = props;
	return (
		<div
			className={
				index === 6
					? index2 === 23
						? 'celdaTablaSolicitarCambiosFinAbajo'
						: 'celdaTablaSolicitarCambiosFin'
					: index2 === 23
					  ? 'celdaTablaSolicitarCambiosAbajo'
					  : 'celdaTablaSolicitarCambios'
			}
			style={{
				gridColumn: `${index + 2} / ${index + 3}`,
				gridRow: `${index2 + 2} / ${index2 + 3}`,
			}}
		>
			{lista.map((servicio, index3) => {
				let color = '';
				let seleccionado = true;
				let nombre = '';
				leyendaCuidados.map((cuidado, index4) => {
					if (cuidado[1] === servicio) {
						color = cuidado[0];
						seleccionado = cuidado[2];
						nombre = servicio;
					}
				});
				if (seleccionado) {
					return (
						<div
							className='servicioCeldaSC'
							onClick={() => seleccionarDia2([nombre, [index, index2]])}
							style={{
								'background-color': color + '4a',
								color: color,
								'border-color': color,
							}}
						>
							{modoMobile ? null : servicio}
						</div>
					);
				}
			})}
		</div>
	);
};
